<div class="bottom-navigation fixed-bottom mt-20 " *ngIf="userRole==='Administrator'">
  <div [ngClass]="getClassForRoute('/Admin')" >
    <a routerLink="/Admin">
      <i class="bi bi-grid-1x2-fill text-primary" style="font-size: 20px;"></i>
    </a>
</div>

<div [ngClass]="getClassForRoute('/ManueDash')">
  <a routerLink="/ManueDash">
   <i class="pi pi-objects-column text-primary" style="font-size: 20px;"></i>
  </a> 
</div>
<div [ngClass]="getClassForRoute('/UserInterestManu')">
 <a routerLink="/UserInterestManu">
  <i class="fa-solid fa-magnet text-primary" style="font-size: 20px;"></i> </a>
</div>
<div [ngClass]="getClassForRoute('/bussinessLeadPage')"> 
<a routerLink="/bussinessLeadPage">
   <i class="fas fa-briefcase text-primary" style="font-size: 20px;"></i>
 </a>
</div>
<div [ngClass]="getClassForRoute('/BusinessInsights')"> 
<a routerLink="/BusinessInsights">
   <i class="fas fa-chart-line  text-primary" style="font-size: 20px;"></i>
 </a>
</div>
<div [ngClass]="getClassForRoute('/EconomicAssistance')">
<a routerLink="/EconomicAssistance">
   <i class="fa-solid fa-wand-magic-sparkles text-primary" style="font-size: 20px;"></i>
 </a>
</div>


<div [ngClass]="getClassForRoute('/userContacts')"> 
<a routerLink="/userContacts">
   <i class="pi pi-address-book text-primary" style="font-size: 20px;"></i>
 </a>
</div>

</div>

<div class="bottom-navigation fixed-bottom mt-20" *ngIf="userRole!=='Administrator'">
  <div [ngClass]="getClassForRoute('/ManueDash')">
    <a routerLink="/ManueDash">
     <i class="pi pi-objects-column text-primary" style="font-size: 20px;"></i>
    </a> 
  </div>
  <div [ngClass]="getClassForRoute('/UserInterestManu')">
   <a routerLink="/UserInterestManu">
    <i class="fa-solid fa-magnet text-primary" style="font-size: 20px;"></i> </a>
 </div>
 <div [ngClass]="getClassForRoute('/bussinessLeadPage')"> 
  <a routerLink="/bussinessLeadPage">
     <i class="fas fa-briefcase text-primary" style="font-size: 20px;"></i>
   </a>
</div>
<div [ngClass]="getClassForRoute('/BusinessInsights')"> 
  <a routerLink="/BusinessInsights">
     <i class="fas fa-chart-line  text-primary" style="font-size: 20px;"></i>
   </a>
</div>
<div [ngClass]="getClassForRoute('/EconomicAssistance')">
  <a routerLink="/EconomicAssistance">
     <i class="fa-solid fa-wand-magic-sparkles text-primary" style="font-size: 20px;"></i>
   </a>
</div>


<div [ngClass]="getClassForRoute('/userContacts')"> 
  <a routerLink="/userContacts">
     <i class="pi pi-address-book text-primary" style="font-size: 20px;"></i>
   </a>
</div>

</div>



